import { get } from './helper';

export async function getMenu(id) {
  const res = await get({
    url: `group_buyings/${id}`,
    version: 2,
  });
  return res?.data || res;
}

export async function getMenuList(type) {
  const res = await get({
    url: `group_buyings/v2?type=${type}`,
    version: 2,
  });
  return res?.data || res;
}

export async function getSharedMenu(key) {
  const res = await get({
    url: `group_buyings/guest/${key}`,
    version: 2,
  });
  return res?.data || res;
}

export default {
  getMenu,
  getMenuList,
  getSharedMenu,
};
